export default {
  data() {
    return {
      confirm: true,
    };
  },
  computed: {
    total() {
      return this.cart.total;
    }
  },
  watch: {
    cart(cart) {
      this.confirm = cart ? cart.confirm : false;
    },
  },
  methods: {
    handleConfirm(event) {
      let cart = this.cart;
      cart.confirm = event;

      this.$store.dispatch('SET_CART', cart);
    },
    goToCheckout() {
      if (this.cart.confirm || this.checkout.authType) {
        this.$router.push(this.i18nLink('checkout'));
      } else {
        this.showConfirmModal();
      }
    }
  },
  created() {
    this.confirm = this.cart ? this.cart.confirm : false;
    this.$store.dispatch('SET_UUID', null);

    if (this.checkout && !this.checkout.coupon) {
      this.getRandomCoupon();
    }

    this.$store.dispatch('SET_SET', null);
  },
};
